import { Modal } from '@/components/Layout';
import React from 'react';
import { usePackage } from './package.hook';
import { Button } from '@/components/Common';

const ValidationPackageDeletion = () => {
  const {
    packageDeletionModal,
    openPackageDeletionModal,
    isDeletePending,
    onDeletePackage,
  } = usePackage();

  return (
    <Modal
      isOpen={packageDeletionModal}
      onClose={openPackageDeletionModal}
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-white text-xl font-bold text-center mb-2">
          Supprimer le package
        </h3>
        <p className="text-center text-gray-400 mx-auto my-0">
          Êtes-vous sûr de vouloir supprimer ?{' '}
        </p>
        <div className="flex justify-between items-center gap-6  mt-4">
          <Button
            onClick={openPackageDeletionModal}
            title="Annuler"
            className="!bg-completed hover:!outline-completed hover:!text-completed
                hover:!bg-hoverColor  text-white !px-16"
          />
          <Button
            className="!px-16"
            title={isDeletePending ? 'Suppression en cours...' : 'Supprimer'}
            onClick={onDeletePackage}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ValidationPackageDeletion;
